



























import { Component, Prop, Vue } from 'vue-property-decorator';

import { ISearchResponse } from '@/models/general';
import { highlightPhrase } from '@/utils';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { getMenuIconName } from '@/utils/iconHelper';

@Component({
  components: {
    Typography
  }
})
export default class SearchBarItem extends Vue {
  @Prop() option!: ISearchResponse;
  @Prop() textSearched!: string;
  @Prop({ default: 'normal' }) variant!: string;

  getMenuIconName = getMenuIconName;

  getHighlightPhrase(value: string) {
    return highlightPhrase(value, this.textSearched, true);
  }
}
